import React from 'react';
import Layout from '../../components/Layout/Layout';
import TrendingSubCategories from '../../components/TrendingSubCategories/TrendingSubCategories';
import styles from './TrendingSubCategoriesPage.module.css';

const TrendingSubCategoriesPage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.trendingSubCategoriesStack}>
        <TrendingSubCategories
          componentSize="Desktop 1440"
          selectedCategoryId={9}
        />
      </div>
    </Layout>
  );
};

export default TrendingSubCategoriesPage;